function cov_28h4y4t81z() {
  var path = "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/SinkVersionTwo.tsx";
  var hash = "8cab5fc196d096748d3f43f28d9b87ec615d37a8";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/SinkVersionTwo.tsx",
    statementMap: {
      "0": {
        start: {
          line: 1,
          column: 56
        },
        end: {
          line: 4,
          column: 1
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "8cab5fc196d096748d3f43f28d9b87ec615d37a8"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }

  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_28h4y4t81z = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}

cov_28h4y4t81z();
var Icon = (cov_28h4y4t81z().s[0]++, {
  name: 'sink-version-two',
  svg: "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M12.0001 7.28553L8.75728 10.5284C6.96632 12.3193 6.96632 15.223 8.75728 17.014C10.5482 18.805 13.452 18.805 15.2429 17.014C17.0339 15.223 17.0339 12.3193 15.2429 10.5284L12.0001 7.28553ZM6.98952 18.7818C9.75679 21.549 14.2434 21.549 17.0107 18.7818C19.778 16.0145 19.778 11.5279 17.0107 8.76059L12.0001 3.75L6.98952 8.76059C4.22224 11.5279 4.22224 16.0145 6.98952 18.7818Z\" fill=\"currentColor\"/>"
});
export default Icon;